export const S3_GEOJSON_DIRECTORY = 'geojson';
export const S3_EXPECTED_COMBINED_SOFTENED_GEOJSON_FILE_NAME = 'combined_softened.geojson';
export const S3_EXPECTED_CONNECTIONS_LOOKUP_GEOJSON_FILE_NAME = 'connections_lookup.json';

export function getCombinedSoftenedGeoJsonPath(version: string): string {
  return `${S3_GEOJSON_DIRECTORY}/${version}/${S3_EXPECTED_COMBINED_SOFTENED_GEOJSON_FILE_NAME}`;
}

export function getConnectionsLookupPath(version: string): string {
  return `${S3_GEOJSON_DIRECTORY}/${version}/${S3_EXPECTED_CONNECTIONS_LOOKUP_GEOJSON_FILE_NAME}`;
}
